import styled, { css } from 'styled-components';
import { getFontStyle, rem } from '../../utils';
const hoveredPill = css `
  color: ${({ theme }) => theme.Color.Brand.Primary};
  background: ${({ theme }) => theme.Button.Variant.Outline.Hover.Background};
`;
const disabledPill = css `
  pointer-events: none;
  cursor: not-allowed;
  color: ${({ theme }) => theme.Color.Neutrals.Text};
  background: ${({ theme }) => theme.Color.Neutrals.Light};
  border-color: ${({ theme }) => theme.Color.Neutrals.Light};
`;
const activePill = css `
  color: ${({ theme }) => theme.Color.Brand.Primary};
  border-color: ${({ theme }) => theme.Color.Brand.Primary};

  &:hover,
  &:active {
    color: ${({ theme }) => theme.Color.Neutrals.Paper};
    background: ${({ theme }) => theme.Color.Brand.Primary};
  }
`;
const defaultPill = css `
  color: ${({ theme }) => theme.Color.Neutrals.Dark};
  border-color: ${({ theme }) => theme.Color.Neutrals.Border};

  &:hover,
  &:active {
    ${hoveredPill}
  }
`;
export const StyledPill = styled.a `
  display: inline-block;
  padding: ${({ theme }) => theme.Spacing.Size.XSmall}px
    ${({ theme }) => theme.Spacing.Size.MediumSmall}px;
  ${getFontStyle('Small')};
  border-radius: ${rem(100)};
  border: 1px solid transparent;
  cursor: pointer;
  user-select: none;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};
  box-sizing: border-box;

  :first-letter {
    text-transform: uppercase;
  }

  &:hover,
  &:active {
    transition: all ${({ theme }) => theme.Transition.Timing.In};
  }

  ${({ variant }) => {
    switch (variant) {
        case 'hovered':
            return hoveredPill;
        case 'active':
            return activePill;
        case 'disabled':
            return disabledPill;
        default:
            return defaultPill;
    }
}}
`;
//# sourceMappingURL=Pill.style.js.map